module.exports = __webpack_public_path__ + "static/media/border-center-h.eb7ac62d.svg";